import { render } from "./ImageStats.vue?vue&type=template&id=8db9d834&scoped=true"
import script from "./ImageStats.vue?vue&type=script&lang=js"
export * from "./ImageStats.vue?vue&type=script&lang=js"

import "./ImageStats.vue?vue&type=style&index=0&id=8db9d834&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8db9d834"]])

export default __exports__